import { render } from "./PageFooters.vue?vue&type=template&id=a8f05bcc&scoped=true"
import script from "./PageFooters.vue?vue&type=script&lang=js"
export * from "./PageFooters.vue?vue&type=script&lang=js"

import "./PageFooters.vue?vue&type=style&index=0&id=a8f05bcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8f05bcc"]])

export default __exports__